import React from 'react';
import { useAuth } from '../../auth/Auth';
import { useNavigate } from "react-router-dom";
import { Button, Tooltip } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';

interface LogoutProps {
}

function Logout({ }: LogoutProps) {
  const auth = useAuth();
  const navigate = useNavigate();
  
  const handleLogOut = async () => {
    auth.logout();
    navigate("/login");
  };

  
  // Desktop version - icon only with tooltip
  return (
    <Tooltip title="Logout" placement="bottom">
      <Button
        type="text"
        icon={<LogoutOutlined style={{ fontSize: '18px' }} />}
        onClick={handleLogOut}
        style={{ 
          color: 'var(--primary-color)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minWidth: '36px',
          height: '36px'
        }}
        aria-label="Logout"
      />
    </Tooltip>
  );
}

export default Logout;